module.exports = __webpack_public_path__ + "img/败酱草.a85a50ab.jpg";